var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-ui-button-kit",on:{"click":_vm.Handle_OnClick}},[_c('h6',[_vm._v(_vm._s(_vm.featureName))]),_c('figure',[_c('img',{staticClass:"filter-invert",attrs:{"src":_vm.iconUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }